module.exports = __webpack_public_path__ + "img/apartahoteles.18a1b853.png";